import { Box, Typography, useMediaQuery } from '@mui/material';
import { theme } from '~/theme';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { styles } from '~/modules/identification/forms/BusinessRelations/styles.ts';
import { TableHeader } from '~/components/ListCardTable/TableHeader.tsx';
import { TFinancialCondition } from '~/modules/identification/forms/FinancialCondition/types.ts';
import {
  bankAccountsTableColumns,
  EMPTY_BANK_ACCOUNTS,
} from '~/modules/identification/forms/FinancialCondition/constants.ts';
import { FormCheckbox } from '~/components/FormComponents/FormCheckbox.tsx';
import { BankAccountsTable } from '~/modules/identification/forms/FinancialCondition/components/BankAccounts/BankAccountsTable.tsx';
import { commonStyles } from '~/theme/styles/commonStyles';

export const BankAccounts = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { watch, control, clearErrors } = useFormContext<TFinancialCondition>();
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: 'bankAccounts',
  });
  const noOtherBankAccounts = watch('noOtherBankAccounts');

  const handleChange = (isChecked: boolean) => {
    if (!isChecked) {
      replace([EMPTY_BANK_ACCOUNTS]);
    } else {
      replace([]);
      clearErrors('bankAccounts');
    }
  };

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
        <FormCheckbox
          name="noOtherBankAccounts"
          label="Рахунки в інших банках відсутні"
          onChange={handleChange}
        />
      </Box>

      {!noOtherBankAccounts && (
        <Box>
          <Typography variant="h5" sx={{ textAlign: 'center', pb: 3 }}>
            Відомості про всі рахунки, що відкриті в інших банках на дату заповнення Анкети -
            опитувальника
          </Typography>
          <Box sx={styles.table}>
            {!isMobile && <TableHeader columns={bankAccountsTableColumns} showActions={false} />}
            <Box sx={{ ...commonStyles.columnFlexContainer, gap: { sm: 2, md: 0, xs: 2 } }}>
              {fields.map((field, index: number) => (
                <BankAccountsTable
                  key={field.id}
                  index={index}
                  showRemove={fields.length > 1}
                  append={append}
                  remove={remove}
                />
              ))}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};
